import { useEffect } from "react";

type RefType = React.RefObject<HTMLElement>;

export const useClickOutsideCloseModal = (
  refs: RefType[],
  callback: () => void
) => {
  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      const isOutside = refs.every((ref) => {
        const el = ref.current;
        if (!el) return true;

        // ref 내부 클릭 시 무시
        if (el.contains(e.target as Node)) return false;

        // SignatureCanvas 내부 canvas 클릭 시 무시 (여기가 핵심)
        const canvas = el.querySelector("canvas");
        if (canvas && canvas.contains(e.target as Node)) return false;

        return true;
      });

      if (isOutside) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [refs, callback]);
};
